import { createAsyncThunk } from "@reduxjs/toolkit";
import { getAccountHistory, getAllOrders, getAllPosition, getAllSLTPOrders } from "../../api/request/dashboard/dashboard";

export const fetchAllOrders = createAsyncThunk('orders/get', async (accountId) => {
    try {
        const { data } = await getAllOrders(accountId);
        console.log(data?.length)
        return data?.length ? data : [];
    } catch (err) {
        return []
    }
})

export const fetchAccountHistory = createAsyncThunk('accountHistory/get', async (accountId) => {
    try {
        const today = new Date();
        const yyyy = today.getFullYear();
        const mm = String(today.getMonth() + 1).padStart(2, "0");
        const dd = String(today.getDate()).padStart(2, "0");

        const from = `${yyyy}-${mm}-${dd}T00:00:00`;
        const to = `${yyyy}-${mm}-${dd}T23:59:59`;

        const requestData = { from, to, id: accountId };

        const response = await getAccountHistory(requestData);

        if (!response || !response.data) {
            console.warn("No account history data available.");
            return [];
        }
        return response.data;
    } catch (error) {
        console.error("Error fetching account history:", error);
        return [];
    }
})

export const fetchAllPositions = createAsyncThunk('positions/get', async accountId => {
    try {
        const { data } = await getAllPosition(accountId);
        if (!data) {
            return [];
        }
        return data;
    } catch (err) {
        return []
    }
})
export const fetchAllSLTP = createAsyncThunk('sltp/get', async accountId => {
    try {
        const { data } = await getAllSLTPOrders(accountId);
        if (!data) {
            return [];
        }
        return data;
    } catch (err) {
        return []
    }
})